export default __webpack_public_path__ + "static/media/2250.aa128b17.png";